import * as React from 'react';
import {
  Button,
  notification
} from 'antd';
import languagesModal from '../Modals/set/languages';
import removeItem from '../Modals/set/removeItem';
import Table from '../../components/Table'
import Pagination from '../../components/Pagination'
import languagesAPI from '../../API/languages';
import errors from "../../API/error";
import TablePagination from "../../services/tablePagination";
import Settings from "../../layouts/Settings";
import columns from "./columns";

interface IState {
  list: object[],
  pagination: any,
  id: string
  loading: boolean
}

class Languages extends React.Component<any, IState> {
  pagination = new TablePagination();
  state = {
    list: [],
    pagination: {
      total: 0
    },
    loading: true,
    id: ''
  };

  componentDidMount() {
    languagesModal.init({onSubmit: this.handleSubmit});
    removeItem.init({onSubmit: this.handleRemove, name: "Language"});
    this.getLanguages();
  };

  componentWillUnmount(): void {
    languagesModal.remove();
    removeItem.del();
  }

  getLanguages = async () => {
    try {
      this.setState({loading: true});
      const query: any = this.state.pagination;
      const result = await languagesAPI.get({query: {...query, ...this.pagination.requestParams()}});
      const {list, pagination} = result.data;
      this.pagination.value = pagination;
      this.setState({list, pagination, loading: false})
    } catch (e) {
      errors.handle(e);
      this.setState({list: [], loading: false})
    }
  };

  addPosition = () => languagesModal.open();

  handleSubmit = async ({values, onLoading, onCancel, form, modalProps: mp = {}}: any) => {
    try {
      onLoading(true);
      if (mp._id) {
        await languagesAPI.update(values, {params: {id: mp._id}});
      } else {
        await languagesAPI.create(values);
      }
      await this.getLanguages();
      onLoading(false);
      onCancel();
    } catch (e) {
      errors.handle(e, form, {priority: 'form'});
      onLoading(false);
    }
  };

  handleEdit = (item: any) => {
    this.setState({id: item._id});
    languagesModal.open(item);
  };

  handleRemove = async (params: any) => {
    const {modalProps: {_id: id}, onCancel, onLoading} = params;
    try {
      onLoading(true);
      await languagesAPI.remove(null, {params: {id}});
      await this.getLanguages();
      notification.success({message: 'Success'});
      onCancel();
    } catch (e) {
      errors.handle(e);
    } finally {
      onLoading(false);
    }
  };

  changePage = (page: number) => {
    this.pagination.page = page;
    this.getLanguages();
  };

  render() {
    const {list, loading} = this.state;
    return <Settings location={this.props.location} actionsComponent={
      <Button className="ant-btn-primary" onClick={this.addPosition}>
        Create Language
      </Button>
    }>
        <Table dataSource={list}
               rowKey="_id"
               loading={loading}
               columns={columns({
                 actions: {
                   onEdit: this.handleEdit,
                   onRemove: removeItem.open
                 }
               })}
               pagination={this.pagination.tableConfig} />
      <Pagination {...this.pagination.config} onChange={this.changePage} />
    </Settings>
  }
}

export default Languages;